<ng-container *ngIf="faqContent$ | async">
  <div class="help-center__content">
    <div [innerHTML]="faqContent"></div>
  </div>
</ng-container>
